import { ProductInfo } from "../../../../common/dataClass/Product";
import { InputBoX } from "../../../../common/dataClass/Default";
import globalData from "../../../../common/globalData";

/**产品基本信息键值对对应表 */
let productInfoKey = {
  'pictureUrl': 'img',
  'productName': 'name',
  'productModel': 'model',
  'productId': 'id',
  'productType': 'sort',
  'productUnit': 'unit',
  'productStatus': 'productStatus',
  'productLength': 'long',
  'productWidth': 'width',
  'productHeight': 'height',
  'productWeight': 'weight',
  'cartonLength': 'boxLong',
  'cartonWidth': 'boxWidth',
  'cartonHeight': 'boxHeight',
  'cartonWeight': 'boxWeight',
  'cartonNum': 'boxNum',
  // 'customsCode': 'HSCode',
  'updateTime': 'time'
}

/**出口产品信息键值对对应表 */
let exportPRoductInfoKey = {
  'productNameEn': 'nameByEnglish',
  'productMaterialZh': 'material',
  'productMaterialEn': 'materialByEnglish',
  'productPurposeZh': 'purpose',
  'productPurposeEn': 'purposeByEnglish',
  'customsPrice': 'tariff',
  'productBrand': 'brand',
  'customsCode': 'HSCode',
  'remarks': 'remarks',
}

class Product extends ProductInfo{
  constructor() {
    super()
    /**产品名称(英文) */
    this.nameByEnglish = ''
    /**产品材质(英文) */
    this.materialByEnglish = ''
    /**产品材质(中文) */
    this.material = ''
    /**产品品牌 */
    this.brand = ''
    /**产品用途(英文) */
    this.purposeByEnglish = ''
    /**产品用途(中文) */
    this.purpose = ''
    /**产品备注 */
    this.remarks = ''
    /**海关申报单价 */
    this.tariff = ''
    /**海关编码 */
    this.HSCode = ''
    /**供应商ID */
    this.supplierId = ''
    /**采购单价 */
    this.purchasePrice = ''
  }
  /**数据初始化 */
  /**产品新建请求体 */
  get getSaveTempAxiosBody(){
    let obj = {
      'picture': this.img,
      'productName': this.name,
      'productModel': this.id,
      'productType': this.sort,
      'productUnit': this.unit,
      'productStatus': this.productStatus,
      'supplier': [{supplierId: this.supplierId, purchasePrice: this.purchasePrice}],
      'productLength': this.long,
      'productWidth': this.width,
      'productHeight': this.height,
      'productWeight': this.weight,
      'cartonLength': this.boxLong,
      'cartonWidth': this.boxWidth,
      'cartonHeight': this.boxHeight,
      'cartonWeight': this.boxWeight,
      'cartonNum': this.boxNum,
      'remarks': this.remark,
      'exportProductInfo': {
        'productNameEn': this.nameByEnglish,
        'productMaterialZh': this.material,
        'productMaterialEn': this.materialByEnglish,
        'productPurposeZh': this.purpose,
        'productPurposeEn': this.purposeByEnglish,
        'customsPrice': this.tariff,
        'productBrand': this.brand,
        'customsCode': this.HSCode,
        'remarks': this.remarks,
      }
    }
    return obj
  }
  /**修改产品信息请求体 */
  get getUpdateProductAxiosBody(){
    let obj = {
      ...this.getSaveTempAxiosBody,
      'productId': this.id
    }
    return obj
  }
  /**数据初始化 */
  init(){
    super.init()
    this.nameByEnglish = ''
    this.materialByEnglish = ''
    this.material = ''
    this.brand = ''
    this.purposeByEnglish = ''
    this.purpose = ''
    this.remarks = ''
    this.tariff = ''
    this.HSCode = ''
    this.supplierId = ''
    this.purchasePrice = ''
  }
  /**后端返回的详情数据 */
  backendDetailDataParsing(obj){
    let pKeys = Object.keys(productInfoKey)
    let eKeys = Object.keys(exportPRoductInfoKey)
    let pStatus = obj.productStatus
    pKeys.map(key => {
      this[productInfoKey[key]] = obj[key]
    })
    eKeys.map(key => {
      this[exportPRoductInfoKey[key]] = obj.exportProductInfo[key]
    })
    this.productStatus = pStatus.map(index => globalData.productStatusInputOptions[index])
    this.purchasePrice = obj.supplier[0].purchasePrice
    this.supplierId = obj.supplier[0].supplierId
  }
}

class ProductInputBox extends InputBoX{
  constructor(type, name, data, obj = { pla: '', isDisable: false, isRequired: true, unit: '', tips: '' }) {
    super(type, name, data, obj)
    /**无数据是否提示 */
    this.isPrompt = false
    /**是否必填 */
    this.isRequired = obj.isRequired == undefined ? true : obj.isRequired
    /**后面显示单位 */
    this.unit = obj.unit
    /**提示文字 */
    this.tips = obj.tips ? obj.tips : ''
    /**前面符号 */
    this.preUnit = obj.preUnit? obj.preUnit: ''
  }
}

class ProductNewModule{
  /**产品基本信息输入框 */
  static NEWBASICINFO(){
    let arr = [
      {
        id: new ProductInputBox('text', '产品ID/型号', 'model'),
        name: new ProductInputBox('text', '产品名称', 'name'),
        sort: new ProductInputBox('select', '产品分类', 'sort'),
        productStatus: new ProductInputBox('select', '产品状态', 'productStatus'),
        unit: new ProductInputBox('select', '计价单位', 'unit'),
        remark: new ProductInputBox('text', '产品备注', 'remark', { isRequired: false })
      },
      {
        size: new ProductInputBox('text', '产品包装尺寸', 'size', { unit: '(cm)' }),
        weight: new ProductInputBox('number', '产品包装重量', 'weight', { unit: '(kg/箱)' }),
        boxSize: new ProductInputBox('text', '外箱包装尺寸', 'boxSize', { unit: '(cm)' }),
        boxWeight: new ProductInputBox('number', '外箱包装重量', 'boxWeight', { unit: '(kg/箱)' }),
        boxNum: new ProductInputBox('number', '装箱数量', 'boxNum', { unit: '(/箱)' }),
        numByCube: new ProductInputBox('number', '1立方产品数量', 'numByCube', { isDisable: true, isRequired: false })
      }
    ]
    return arr
  }
  /**出口产品补充信息输入框 */
  static NEWEXPORTINFO(){
    let arr = [
      {
        nameByEnglish : new ProductInputBox('text', '产品名称', 'nameByEnglish', { tips: '(英文)' }),
        materialByEnglish : new ProductInputBox('text', '产品材质', 'materialByEnglish', { pla: 'eg:Electronic Component ABS Plastics', tips: '(英文)' }),
        material : new ProductInputBox('text', '产品材质', 'material', { pla: '例：电子元件+ABS塑料', tips: '(中文)' }),
        brand : new ProductInputBox('text', '产品品牌', 'brand', { pla: '请输入品牌名称,无品牌请输入"无";' }),
      },
      {
        empty : new ProductInputBox(),
        purposeByEnglish : new ProductInputBox('text', '产品用途', 'purposeByEnglish', { pla: 'eg:Home Lighting & Decoration', tips: '(英文)' }),
        purpose : new ProductInputBox('text', '产品用途', 'purpose', { pla: '例：家居照明及装饰', tips: '(中文)' }),
        remarks : new ProductInputBox('text', '出口产品备注', 'remarks', { pla: '请输入备注信息(不能超过50字)', isRequired: false }),
      },
      {
        empty : new ProductInputBox(),
        materialByEnglish : new ProductInputBox('text', '海关申报单价', 'tariff', { tips: '(美金)', preUnit: 'icon-meiyuan_o' }),
        material : new ProductInputBox('text', '海关编码', 'HSCode', { tips: '(HSCode)' }),
      }
    ]
    return arr
  }
  /**产品包装尺寸 */
  static NEWSIZE(){
    let arr = [
      new ProductInputBox('input', '长', 'long'),
      new ProductInputBox('input', '宽', 'width'),
      new ProductInputBox('input', '高', 'height'),
    ]
    return arr
  }
  /**外箱包装尺寸 */
  static NEWBOXSIZE(){
    let arr = [
      new ProductInputBox('input', '长', 'boxLong'),
      new ProductInputBox('input', '宽', 'boxWidth'),
      new ProductInputBox('input', '高', 'boxHeight'),
    ]
    return arr
  }
  /**非必填数据 */
  static NOINPUTDATA(){
    let arr = ['remark', 'numByCube', 'remarks']
    return arr
  }
}

export {
  Product, ProductInputBox, ProductNewModule, productInfoKey
}
